export default __webpack_public_path__ + "static/castright-92010557ee4422f06d4b93eab0b24ffd.png";